import { cn } from '@/lib/utils';
import { linkifyText } from '@rock/util';
import { type FC, useMemo } from 'react';

/**
 * Plain source text with its web addresses, emails and phone numbers as links — the same segments the app
 * and the emails render, so admin shows exactly what a homeowner can tap. Line breaks are kept.
 */
export const LinkedText: FC<{ text: string; className?: string }> = ({ text, className }) => {
    const segments = useMemo(() => linkifyText(text), [text]);
    return (
        <span className={cn('whitespace-pre-line', className)}>
            {segments.map((segment, index) =>
                segment.kind === 'link' ? (
                    <a
                        key={index}
                        href={segment.href}
                        className="text-primary underline-offset-2 hover:underline"
                        {...(segment.scheme === 'web' ? { target: '_blank', rel: 'noreferrer' } : {})}
                    >
                        {segment.text}
                    </a>
                ) : (
                    segment.text
                ),
            )}
        </span>
    );
};
